module.exports = __webpack_public_path__ + "img/voice.a5bb88fa.svg";